import { createContext, useContext, useEffect, useState } from 'react';
import { createRefPath } from '../../firestoreData/appData/appRefPaths';
import { AppSettingsContext } from './AppSettingsContext';
import { DatabaseContext } from './DatabaseContext';
import { FunctionsContext } from './FunctionsContext';
import { AppParentContext } from './AppParentContext';

/** Returns all the forms (objects) needed for the App */
export const AppFormsContext = createContext();


/** This will get the homeSettings and clientSettings */
const AppFormsProvider = (props) => {

  // appParentContext
  const appParentContext = useContext(AppParentContext);
  const { fn_cls } = appParentContext ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_handlers } = appSettingsContext ?? {}

  const [appForms, setAppForms] = useState()
  const [formsUpdated, setFormsUpdated] = useState()

  const getForms = async () => {
    const vvProps = {};
    try {
      const cb = (res) => {
        const { error } = res;
        if (error) {
          appSettings_handlers.handleError_app(error);
        } else {
          setAppForms(res);
        }
      };
      getAppForms(fn_cls, database_fns, cb, setFormsUpdated, vvProps);
    } catch (error) {
      // Handle any error that might arise from async calls
      console.error("Error fetching forms:", error);
      appSettings_handlers.handleError_app(error);
    }
  };

  useEffect(() => {
    getForms()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const providerContext = () => <AppFormsContext.Provider value={{ appForms_state: { appForms: appForms, formsUpdated }, appForms_fns: { getForms } }}>
    {props.children}
  </AppFormsContext.Provider>

  return providerContext()
  // return appForms ? providerContext() : <div></div>

}

export default AppFormsProvider

const getAppForms = (fn_cls, database_fns, callback, callback2, vvProps) => {
  const docName = 'appForms'
  database_fns.get_data({ refPath: createRefPath(['_appForms', docName]), opts: { returnFirstObject: true, ignoreId: true } }).then(appForms => {
    const { error } = appForms ?? {}
    if (error) {
      callback(error)
    } else {
      if (appForms && Object.keys(appForms).length === 0) {
        fn_cls.getAppForms(vvProps).then(appForms => {
          callback2(appForms)
          callback(true)
        })
      } else {
        callback(appForms ?? {})
        callback2(true)
      }
    }
  }).catch(err => {
    console.error('getAppForms', err)
    callback({ error: err })
  })
}